import { jsx } from "react/jsx-runtime";
import { LAYOUT } from "./constants.js";
function PageHeader({ isEven, bleedPx = 0 }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "relative w-full",
      style: {
        height: LAYOUT.header.totalHeight,
        background: "#FEF1CB"
      },
      children: /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            position: "absolute",
            bottom: -1,
            left: isEven ? 0 : bleedPx,
            right: isEven ? bleedPx : 0,
            height: LAYOUT.header.curveHeight + 1,
            background: "#ffffff",
            ...isEven ? { borderTopRightRadius: LAYOUT.header.curveHeight } : { borderTopLeftRadius: LAYOUT.header.curveHeight }
          }
        }
      )
    }
  );
}
export {
  PageHeader
};
//# sourceMappingURL=PageHeader.js.map
